export default __webpack_public_path__ + "images/models/5132d105c25df148024525694ff70cb1.usdz";